import React, { useState } from 'react'
import { Drawer, notification, Card, Input, DatePicker } from 'antd'
import { InputBox } from '../../../components/_utils/appUtils'
import { addDirectDepositFxn } from '../actions'
import { useDispatch } from 'react-redux'
import AgentTypeheadComponent from '../../../components/_utils/AgentTypeheadComponent'

let directDepositInitState = {
  amount: null,
  depositDate: null,
  details: '',
  receipt: null
}

const DirectDepositDrawer = (props) => {
  // let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  let [directDepositState, setDirectDepositState] = useState(directDepositInitState)
  let [agentId, setAgentId] = useState('')

  let dispatch = useDispatch()
  let { visible, onClose, onSubmit } = props
  let events = {
    _updateDirectDepositState: (data) => {
      setDirectDepositState((prevState) => {
        return {
          ...prevState,
          ...data
        }
      })
    },
    addDirectDeposit: async (e) => {
      e.preventDefault()
      const formDataToSend = new FormData()

      if (!agentId) {
        notification.warning({ message: 'Please choose agent' })
        return
      }
      if (!directDepositState.amount) {
        notification.warning({ message: 'Please enter amount' })
        return
      }
      if (isNaN(Number(directDepositState.amount))) {
        notification.warning({ message: 'Please enter a valid amount' })
        return
      }

      if (!directDepositState.depositDate) {
        notification.warning({ message: 'Please select deposit date' })
        return
      }
      let obj = {
        ...directDepositState,
        status: 'Pending',
        agentId:agentId
      }

      formDataToSend.append('obj', JSON.stringify(obj))
      if (directDepositState.receipt) {
        formDataToSend.append('receipt', directDepositState.receipt)
      }

      let resp = await dispatch(addDirectDepositFxn(formDataToSend))
      if (resp && resp.success) {
        setDirectDepositState(directDepositInitState)
        onSubmit()
      }
    }
  }
  return (
    <>
      <Drawer title={'Add Direct Deposit'} width={'30%'} onClose={onClose} visible={visible}>
        <Card>
          <InputBox title={'Select Agent'} labelCls={'labelDoc'}>
            <AgentTypeheadComponent
              key={agentId}
              agentId={agentId}
              dispatch={dispatch}
              customStyle=''
              onSelect={item => setAgentId(item)}
              blockStatus={false}
            />
          </InputBox>
          <InputBox title={'Enter Deposit Amount'}>
            <Input size={'small'}
                   type={'number'}
                   placeholder={'Enter deposit amount'}
                   value={directDepositState.amount}
                   onChange={(value) => {
                     events._updateDirectDepositState({ amount: value.target.value })
                   }}
            />
          </InputBox>
          <InputBox title={'Deposit Date'}>
            <DatePicker
              className={'form-control'}
              value={directDepositState.depositDate}
              onChange={(value) => {
                events._updateDirectDepositState({ depositDate: value })
              }}
            />
          </InputBox>
          <InputBox title={'Details'}>
            <Input size={'small'}
                   type={'textArea'}
                   placeholder={'Enter Details'}
                   value={directDepositState.details}
                   onChange={(value) => {
                     events._updateDirectDepositState({ details: value.target.value })
                   }}
            />
          </InputBox>
          <InputBox title={'Receipt'}>
            <input
              type='file'
              className='form-control'
              onChange={(e) => {
                const file = e.target.files[0]
                events._updateDirectDepositState({ receipt: file })
              }}
            />
          </InputBox>

          <a className='btn btn-primary '
             onClick={events.addDirectDeposit}
          >
            Submit
          </a>
        </Card>
      </Drawer>
    </>
  )
}
export default DirectDepositDrawer
